/**
 * HierarchyBreadcrumb — visualizacao da cadeia de cargos (ancestrais).
 *
 * Renderiza "Master ▸ Coordenador ▸ Gestor de PCP" como breadcrumb
 * clicavel (cada item navega para a ficha do cargo). O ultimo item
 * (current) e destacado e nao-clicavel.
 *
 * Props:
 * - `chain`: [{ id, nome, current? }] em ordem ancestral -> atual
 * - `onSelect(id)`: opcional
 */
import React from "react";
import styled from "styled-components";
import { FiChevronRight } from "react-icons/fi";

const Wrap = styled.nav`
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  font-size: 0.8rem;
  color: ${({ theme }) => theme.textSecondary};
`;

const Item = styled.button`
  appearance: none;
  background: transparent;
  border: 0;
  padding: 2px 6px;
  border-radius: 6px;
  color: ${({ theme, $current }) =>
    $current ? theme.textPrimary : theme.textSecondary};
  font-weight: ${({ $current }) => ($current ? 600 : 400)};
  cursor: ${({ $current }) => ($current ? "default" : "pointer")};

  &:hover {
    ${({ $current, theme }) =>
      $current ? "" : `background: ${theme.surfaceAlt};`}
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.accent};
    outline-offset: 1px;
  }
`;

const Sep = styled.span`
  display: inline-flex;
  opacity: 0.5;
`;

function HierarchyBreadcrumb({ chain = [], onSelect }) {
  if (!chain.length) return null;
  return (
    <Wrap aria-label="Cadeia hierarquica de cargo">
      {chain.map((item, idx) => (
        <React.Fragment key={item.id || item.nome}>
          <Item
            type="button"
            $current={item.current || idx === chain.length - 1}
            onClick={() => {
              if (!(item.current || idx === chain.length - 1)) {
                onSelect?.(item.id);
              }
            }}
            disabled={item.current || idx === chain.length - 1}
          >
            {item.nome}
          </Item>
          {idx < chain.length - 1 && (
            <Sep aria-hidden="true">
              <FiChevronRight size={12} />
            </Sep>
          )}
        </React.Fragment>
      ))}
    </Wrap>
  );
}

export default HierarchyBreadcrumb;
